import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面未找到 - 麻豆传媒视频",
    description: "你访问的页面不存在或已移动，请返回首页继续浏览影视内容。",
    keywords: "页面未找到,404,影视导航",
  });

  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-20 text-center md:py-28">
      <span className="font-heading text-[80px] font-black leading-none text-primary-100 md:text-[140px]">404</span>
      <div className="-mt-6 md:-mt-10">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
        <p className="mt-3 text-sm text-foreground-600">
          你访问的地址 <span className="font-mono text-foreground-800">{location.pathname}</span> 不存在，可能链接有误或内容已调整。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="flex items-center gap-2 rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-700 whitespace-nowrap"
          >
            <i className="ri-compass-3-line"></i>
            浏览影视分类
          </Link>
        </div>
      </div>
    </div>
  );
}